import { Buffers } from '../buffers'
import { EventLimits, HostMeetingLimits } from '../event_limits'
import { PanelContentContainer } from '../styles'

export const LimitsAndBuffers = ({ isLocked }) => (
  <PanelContentContainer>
    <Buffers isLocked={isLocked} />
    <EventLimits isLocked={isLocked} />
    <HostMeetingLimits />
  </PanelContentContainer>
)
